export default __webpack_public_path__ + "static/media/bg-1.da53687c.jpg";